/* GENERATO da frontend/scripts/generaTipiFile.js — NON MODIFICARE.
   La fonte e' backend/utils/tipoFile.js (le firme e ESTENSIONI): modificare
   li'. Questa copia viene riscritta a ogni build.

   Serve SOLO ai selettori dei file: a decidere che cosa entra e' il server,
   che legge i byte. Un'estensione offerta qui non fa entrare niente. */

export const FORMATI_RICONOSCIUTI = {
    "application/pdf": [
        ".pdf"
    ],
    "image/avif": [
        ".avif"
    ],
    "image/bmp": [
        ".bmp"
    ],
    "image/gif": [
        ".gif"
    ],
    "image/heic": [
        ".heic"
    ],
    "image/heif": [
        ".heif"
    ],
    "image/jpeg": [
        ".jpg",
        ".jpeg"
    ],
    "image/png": [
        ".png"
    ],
    "image/tiff": [
        ".tif",
        ".tiff"
    ],
    "image/webp": [
        ".webp"
    ],
    "video/mp4": [
        ".mp4",
        ".m4v"
    ],
    "video/quicktime": [
        ".mov"
    ],
    "video/webm": [
        ".webm"
    ],
    "video/x-matroska": [
        ".mkv"
    ],
    "video/x-msvideo": [
        ".avi"
    ]
};

/**
 * L'attributo `accept` di un selettore di file: i formati riconosciuti
 * delle famiglie date - un tipo esatto ('application/pdf') o un prefisso che
 * finisce con la barra ('image/') - ognuno col suo tipo e le sue estensioni
 * (il browser, su alcuni sistemi, riconosce solo l'uno o solo le altre).
 */
export function accettaDi(famiglie) {
    return Object.entries(FORMATI_RICONOSCIUTI)
        .filter(([mime]) => famiglie.some((f) => (f.endsWith('/') ? mime.startsWith(f) : mime === f)))
        .flatMap(([mime, estensioni]) => [mime, ...estensioni])
        .join(',');
}
